import { render, staticRenderFns } from "./BatchesFilter.vue?vue&type=template&id=480d1247&scoped=true"
import script from "./BatchesFilter.vue?vue&type=script&lang=js"
export * from "./BatchesFilter.vue?vue&type=script&lang=js"
import style0 from "./BatchesFilter.vue?vue&type=style&index=0&id=480d1247&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480d1247",
  null
  
)

export default component.exports